import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPut } from '@/lib/http/client';
import {
  orgSnowflakeConnectionUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type {
  ChangeSnowflakeSelectionPayload,
  SnowflakeConnectionResponse,
} from '@/lib/portfolio/snowflake-types';

export function useUpdateSnowflakeConnection(orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ChangeSnowflakeSelectionPayload) =>
      apiPut<SnowflakeConnectionResponse>(
        orgSnowflakeConnectionUrl(orgId),
        payload
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeConnection(orgId),
      });
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeRequests(orgId),
      });
    },
  });
}
